import React, { useEffect } from "react";
import { Navigate, useLocation } from "react-router-dom";
import { useDispatch } from "react-redux";
import { loadUser } from "../../store/authSlice";
import { getToken } from "../../lib/api";

/**
 * Guards the admin area. If no token is present, redirects to login.
 * On mount it refreshes the user (permissions) from the server.
 */
export default function ProtectedRoute({ children }) {
  const dispatch = useDispatch();
  const location = useLocation();
  const token = getToken();
  const loginPath = location.pathname.startsWith("/user/")
    ? "/auth/user/login/"
    : "/auth/admin/login/";

  useEffect(() => {
    if (token) dispatch(loadUser());
  }, [dispatch, token]);

  if (!token) {
    return <Navigate to={loginPath} replace />;
  }

  return children;
}
